var ActionsSettingsController = function ($scope, $http) {
    var loadActionsSettings = function () {
        if ($scope.adminOrInRole([])) {
            $http.get('/api/v1/settings/actionsSettings').then(function (response) {
                $scope.actionsSettings = response.data;
            });
        }
    }

    loadActionsSettings();

    function saveActionsSettings() {
        $http.put('/api/v1/settings/actionsSettings', $scope.actionsSettings)
            .success(function (data) {
                $scope.actionsSettings = data;
                $scope.notify("success", "Saved successfully.");
            });
    }

    $scope.$watch('actionsSettings.AutomaticDataCleanup.LongLivedCollectionSettings.Mode', function () {
        if($scope.actionsSettings)
            $scope.longLivedCollectionCleanupOff = $scope.actionsSettings.AutomaticDataCleanup.LongLivedCollectionSettings.Mode === 'None';
    });

    $scope.$watch('actionsSettings.AutomaticDataCleanup.ShortLivedCollectionSettings.Mode', function () {
        if($scope.actionsSettings)
            $scope.shortLivedCollectionCleanupOff = $scope.actionsSettings.AutomaticDataCleanup.ShortLivedCollectionSettings.Mode === 'None';
    });    

    $scope.saveActionsSettings = function () {
        $scope.confirm('Save settings', 'Are you sure you want to save new settings?', saveActionsSettings);
    };
};
ActionsSettingsController.$inject = ["$scope", "$http"];
